import React from "react";
import { Fragment } from "react";
import { FlexBox, Header } from "scuid-x";
import { Footer } from "./Footer";
import "./HeaderAndFooter.css";

export interface HeaderAndFooterProps {
  children: React.ReactChild;
}

export const HeaderAndFooter: React.SFC<HeaderAndFooterProps> = (props) => {
  return (
    <Fragment>
      <FlexBox
        className={"HeaderAndFooter-flex-box"}
        direction={"column"}
        justifyContent={"space-between"}
      >
        <div>
          <Header isNotMenu={true} isNotContact={true} isNotEmail={true} isNotNotifications={true} />
          {props.children}
        </div>
        <Footer/>
      </FlexBox>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/HeaderAndFooter.tsx